import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
const Loading = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "create"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("api-keys", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-2"><SecretKeyLabel /><SecretKeyInput /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-3 mb-4">{t2}<div className="flex flex-col gap-2"><RoleLabel /><RoleInput /></div></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1) {
    t4 = <div aria-label={t1} className="w-full">{t3}</div>;
    $[5] = t1;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
const SecretKeyLabel = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Shimmer height="20px" width="110px" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const SecretKeyInput = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Shimmer height="40px" width="395px" className="max-md:max-w-full" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const RoleLabel = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Shimmer height="20px" width="99px" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const RoleInput = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Shimmer height="40px" width="194px" className="max-md:max-w-full" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Loading;
function _temp($) {
  return $.form.loadingAria;
}